import React from 'react';

import AppStoreButton from './buttons/AppStoreButton';
import GooglePlayButton from './buttons/GooglePlayButton';

function MobileInstallButtons(props) {
  const alignClassName = props.align === 'left' && !props.isMobile
    ? 'items-start justify-start'
    : 'items-center justify-center';

  return (
    <div className={`mt-4 flex flex-col gap-3 sm:flex-row ${alignClassName}`}>
      <div className={`${props.isMobile ? '' : 'text-right'} flex justify-center`}>
        <GooglePlayButton></GooglePlayButton>
      </div>
      <div className={`${props.isMobile ? '' : 'text-left'} flex justify-center`}>
        <AppStoreButton></AppStoreButton>
      </div>
    </div>
  );
}

MobileInstallButtons.defaultProps = {
  isMobile: false,
  align: 'center'
};

export default MobileInstallButtons;
